<!-- <div class="flex items-center justify-center m-auto bottom-0 mt-4">
    <p class="copy text-center text-black pl-10 dark:text-white bottom-0 animate__animated animate__backInDown animate__delay-1s">
      &copy; 2024 PITZON. {{ 'HOME.FOOTER' | translate }} By TuulApp
    </p>
  </div> -->
  <div class="bg-white dark:bg-azulOscuro dark:text-white text-azulOscuro py-4 flex flex-col  items-center">
    <p class="flex items-center gap-2">
        © {{ currYear }}. {{ 'HOME.FOOTER' | translate }} By&nbsp;
        <img class="w-20" src="https://tuulapp.com//assets/images/logo/logo.svg" alt="Tuulapp Logo">
    </p>
</div>
